/*

MIT License

Copyright (c) 2022 Valery Zinchenko

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

*/

import { useEffect, useState } from "react"

import Localization, { llType, Localize } from "./controller"

function useLocalization<Selector extends ((ll: llType) => Selected | undefined) | undefined, Selected extends Record<string, unknown> = llType>(selector?: Selector): Selector extends undefined ? {} : Selected {
  const [localization, setLocalization] = useState(selector ? Localize(selector) : {} as never)
  useEffect(() => {
    return Localization.onTransition(() => {
      if (!selector) {
        return setLocalization({} as never)
      }
      setLocalization(Localize(selector))
    })
  }, [])
  return localization
}

export default useLocalization
